// src/components/ProtectedRouteNPC.js
import React from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { isTokenExpired, getDecodedToken } from '../utils/authUtils';

const ProtectedRouteNPC = ({ children, requiredRole }) => {
  const location = useLocation();
  const token = localStorage.getItem('npcAuthToken');

  if (!token || isTokenExpired(token)) {
    localStorage.removeItem('npcAuthToken');
    localStorage.removeItem('currentUser');

    const redirectTo = encodeURIComponent(location.pathname + location.search);
    return <Navigate to={`/login?redirectTo=${redirectTo}`} replace />;
  }

  const decoded = getDecodedToken(token);

  if (!decoded) {
    return <Navigate to="/login" replace />;
  }

  if (requiredRole && decoded.role !== requiredRole) {
    console.warn('Insufficient permissions. Redirecting...');
    return <Navigate to="/" replace />;
  }

  return React.cloneElement(children, { currentUser: decoded });
};

export default ProtectedRouteNPC;
